import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useCreateNps() {
  const [isSaving, setSaving] = useState(false);

  const create = useCallback(() => {
    setSaving(true);
    return quarkusApi
      .post('/nps', {}, { headers: { Authorization: sessionStorage.getItem('token') } })
      .finally(() => setSaving(false));
  }, []);

  return { create, isSaving };
}
